import { z } from 'zod';
export const SearchSchema = z.object({
  loginId: z.string().optional()
});